import { FC } from 'react';
import styled from 'styled-components';
import { COLORS, device, FONTS } from '../../../constants';
import { BoxChecked, BoxUnchecked } from '../../../assets/svg';
import { Text } from '../../Text/Text';

interface OptionProps {
  text: string;
  isSelected?: boolean;
  onClick?: () => void;
  isMultiple?: boolean;
}

export const Option: FC<OptionProps> = ({
  text,
  isSelected = false,
  onClick,
  isMultiple = false,
}) => {
  return (
    <OptionContainer onClick={onClick} $isSelected={isSelected}>
      <TextWrapper>
        <Text
          text={text}
          size={18}
          fontFamily={FONTS.SUBTITLE}
          color={COLORS.SECTION_TITLE}
        />
      </TextWrapper>
      {isMultiple && (isSelected ? <BoxChecked /> : <BoxUnchecked />)}
    </OptionContainer>
  );
};

const OptionContainer = styled.div<{ $isSelected: boolean }>`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 10px;
  cursor: pointer;
  z-index: 30;
  box-sizing: border-box;
  background-color: ${COLORS.WHITE};
  border-width: 0 1px;
  border-right-color: ${COLORS.INDUSTRY_BORDER};
  border-left-color: ${({ $isSelected }) =>
    $isSelected ? COLORS.MAIN_RED : COLORS.INDUSTRY_BORDER};
  border-style: solid;
`;

const TextWrapper = styled.div`
  flex: 1;
  min-width: 0;

  > h4 {
    white-space: normal;
    word-break: break-word;
  }

  @media screen and ${device.md} {
    > h4 {
      font-size: 14px;
      line-height: 1.5;
    }
  }
`;
